import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { stepContent, header, singleInput, loadingStyle } from "./../style";
import InputForm from "../../../../../shared/atoms/InputForm";

import SeeMore from "../../shared/SeeMore";
import { useNewOfferMobile } from "../../context";
import { useNewOffer } from "../../../../context/new-offer";
import Loading from "../../../../../shared/create-offer/Loading/Loading";

const UserlastName = ({ onChangeLoyalty }) => {
	const { currentProgram: fidelityProgram, loyaltyData, userData, rankingData } = useNewOffer();
	const { setStepError } = useNewOfferMobile();

	const [state, setState] = useState({
		lastName: loyaltyData.data.lastName || loyaltyData.data.lastName || "",
		hasError: false
	});

	useEffect(() => {
		const lastName = loyaltyData.data.lastName || loyaltyData.data.lastName;
		const hasError = lastName !== undefined && !lastName.length;

		setState({
			...state,
			lastName,
			hasError
		});
		setStepError(!lastName || hasError);
	}, [loyaltyData.data]);

	const onChange = ev => {
		let lastName = String(ev.target.value).replace(/[0-9]/g, "");

		setState({ ...state, lastName, hasError: !lastName.length });
		onChangeLoyalty({ lastName, lastName: lastName });
	};

	if (userData.isFetching || rankingData.isFetching) {
		return (
			<div
				className={css`
					${loadingStyle};
				`}
			>
				<Loading width={120} height={120} />
			</div>
		);
	}

	return (
		<div
			className={css`
				${stepContent};
			`}
		>
			<strong
				className={css`
					${header};
				`}
			>
				Dados da {fidelityProgram.fidelityName}
			</strong>
			<div
				className={css`
					${singleInput};
				`}
			>
				<InputForm
					name="lastName"
					id="lastName"
					value={state.lastName}
					onChange={onChange}
					placeholder=""
					label="Sobrenome"
					hasError={state.hasError}
					errorMessage="O campo não pode ser vazio."
				/>
			</div>

			<SeeMore>
				<strong>Por que precisamos desses dados?</strong>

				<p>
					Para fazer a emissão de passagens utilizando suas milhas, a MaxMilhas precisará acessar
					sua conta no programa de fidelidade.
					<br />
					<br />
					Por isso, você deve informar o usuário e a senha de acesso que estão
					cadastrados no site da {fidelityProgram.acronym}.<br />
					<br />
					Lembramos que o titular do programa de fidelidade deve ser o mesmo do cadastro da
					MaxMilhas.
				</p>
			</SeeMore>
		</div>
	);
};

export default UserlastName;
